import React, { useState } from 'react';
import { AlertTriangle, Bomb, Car, CloudLightning, FileText, Flame, HeartPulse, Scale, ShieldAlert, UserX } from 'lucide-react';
import { Card } from '../ui';

const SEV = { 3: ['Alta', '#C93A3F'], 2: ['Media', '#B8620F'], 1: ['Bassa', '#5F656E'] };
const ICON = { conflict: Flame, terror: Bomb, kidnap: UserX, unrest: ShieldAlert, crime: AlertTriangle, customs: Scale, nature: CloudLightning, health: HeartPulse, transport: Car, entry: FileText };

function Attention({ items }) {
  if (!items?.length) return null;
  return (
    <div className="border border-[#E5484D]/60 bg-[#E5484D]/[0.07] rounded-sm p-4 mb-4" data-testid="risk-attention">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#E37A72] mb-3 flex items-center gap-2"><AlertTriangle size={14} />Attenzione · i punti più critici</p>
      <ul className="space-y-2.5">
        {items.map((a, i) => (
          <li key={i} className="text-sm text-[#E5E5E5] leading-snug" data-testid={`risk-attention-${i}`}>
            <span className="text-[11px] uppercase tracking-wider text-[#E37A72] font-semibold mr-2">{a.label}</span>{a.text}
          </li>
        ))}
      </ul>
    </div>
  );
}

function Category({ c }) {
  const [open, setOpen] = useState(false);
  const Icon = ICON[c.id] || AlertTriangle;
  const [lab, col] = SEV[c.severity];
  const pts = open ? c.points : c.points.slice(0, 3);
  return (
    <div className="border border-[#1F242C] rounded-sm p-4 min-w-0" style={{ borderLeft: `3px solid ${col}` }} data-testid={`risk-cat-${c.id}`}>
      <div className="flex items-center gap-2 mb-2">
        <Icon size={15} style={{ color: col }} className="shrink-0" />
        <p className="text-sm font-semibold text-[#F2F2F2] flex-1 truncate">{c.label}</p>
        <span className="text-[10px] uppercase tracking-wider font-bold px-2 py-0.5 rounded-sm text-white" style={{ background: col }} data-testid={`risk-cat-sev-${c.id}`}>{lab}</span>
      </div>
      <ul className="space-y-1.5">
        {pts.map((p, i) => <li key={i} className="text-xs text-[#C9CCD1] leading-snug flex gap-2"><span style={{ color: SEV[p.severity][1] }}>●</span><span>{p.text}</span></li>)}
      </ul>
      {c.points.length > 3 && <button onClick={() => setOpen(!open)} className="text-[11px] text-[#D4AF37] hover:underline mt-2" data-testid={`risk-cat-more-${c.id}`}>{open ? 'Mostra meno' : `${c.points.length - 3 === 1 ? 'Altro 1 punto principale' : `Altri ${c.points.length - 3} punti principali`}${c.count > c.points.length ? ` (${c.count} in totale nella scheda)` : ''}`}</button>}
    </div>
  );
}

export default function RiskBreakdown({ ins }) {
  if (!ins?.categories?.length) return null;
  return (
    <Card className="p-6 mb-4" data-testid="risk-breakdown">
      <p className="text-[11px] uppercase tracking-[0.18em] text-[#D4AF37] mb-3">Rischi per tipologia</p>
      <Attention items={ins.attention} />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">{ins.categories.map((c) => <Category key={c.id} c={c} />)}</div>
    </Card>
  );
}
